exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#report-form #institution .el-select__tags {\n    margin-top: -35px !important;\n}\n", ""]);

// exports
